import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9f795dde&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9f795dde&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=9f795dde&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f795dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f795dde')) {
      api.createRecord('9f795dde', component.options)
    } else {
      api.reload('9f795dde', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9f795dde&scoped=true", function () {
      api.rerender('9f795dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/stock/index.vue"
export default component.exports